module.exports = __webpack_public_path__ + "static/cornices-ab704e32e01026b830a675a43c4705c4.png";